import { useContext } from 'react';

// project imports
import { I18nContext } from 'i18n/I18nContext';

// ==============================|| HOOK - TRADUCCIÓN ||============================== //
// usage: const { t, locale, setLocale, intlLocale } = useTranslation();
//        t('routes.create')            -> "Crear ruta"
//        t('routes.created', { nombre }) -> interpola {{nombre}}

export function useTranslation() {
  const context = useContext(I18nContext);

  if (!context) {
    throw new Error('useTranslation debe usarse dentro de <I18nProvider>');
  }

  return context;
}

export default useTranslation;
